import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

type TableHeaderProps = {
  title: ReactNode;
  align?: 'right' | 'left';
  className?: string;
};

type TwoLineTableHeaderProps = TableHeaderProps & {
  subtitle?: ReactNode;
};

/**
 * Allows header to be vertically centered if there is no subtitle
 */
export const TwoLineHeader = ({
  title,
  subtitle,
  className,
  align,
}: TwoLineTableHeaderProps) => {
  return (
    <div
      className={twMerge(
        '-my-0.5 flex h-8',
        subtitle ? 'flex-col' : 'items-center',
        align === 'right' ? 'justify-end' : 'justify-start',
        className,
      )}
    >
      <div>{title}</div>
      {subtitle && <div>{subtitle}</div>}
    </div>
  );
};

export const OneLineHeader = ({ title, className, align }: TableHeaderProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center',
        align === 'right' ? 'justify-end' : 'justify-start',
        className,
      )}
    >
      <div>{title}</div>
    </div>
  );
};
